import React from "react"
import Layout from "../components/layout"
import { Link } from "gatsby";
import SEO from "../components/seo"
import Container from "../components/container"
import styled from "@emotion/styled"
import Img from "gatsby-image"
import {
  Heading,
  Box,
  PseudoBox,
  Button,
  SimpleGrid,
} from "@chakra-ui/core";
import theme from "../theme"

const Styles = styled.div`
    // box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    // grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
`

export default class extends React.Component {
  constructor(props) {
    super();
    this.state = {};
    this.state.shop = props.data.shop.nodes;
  }

  catalog(node) {
    let color = node.cross == "PCS1" ? theme.teal : theme.teal ;
    return <PseudoBox cursor="pointer" >
      <Link to={"store/" + node.slug}>
        <Box rounded="sm" overflow="hidden" mb={2}>
          <Img fluid={node.resources[0].fluid} alt={node.title} />
        </Box>
      </Link>

      <Box p="6px 14px" color="gray.800" textAlign="center" height="100%">

        <Link to={"store/" + node.slug}>

          <Heading size="sm" mb={1} >
            {node.title}
          </Heading>

        

          <Heading size="md" mb={2}>
            ${node.price.toFixed(2)}
          </Heading>

        </Link>

        <Box mb={2}>
          <Button
            size="sm"
            color={theme.white}
            rounded="full"
            bg={color}
            _hover={{ bg: theme.lightBlue }}
            _active={{ bg: theme.yellow, color: "purple.500" }}
            className="snipcart-add-item"
            data-item-id={node.id}
            data-item-price={node.price}
            data-item-url={"/store/" + node.slug}
            data-item-description={node.body.body}
            data-item-image={"https:" + node.resources[0].fluid.src}
            data-item-name={node.title}
          >
            Add To Cart
                      </Button>
        </Box>

      </Box>


    </PseudoBox>
  }

  render() {
    return (
      <Layout>
        <SEO title="Store" />
        <Styles>

          <Box bg="gray.100">
            <Container>
              <Heading mb={6} textAlign="center">Store</Heading>

              

              <SimpleGrid columns={[2, 3, 4, 5]} mb={12} spacing={8}>

                {
                  this.state.shop.map(this.catalog.bind(this))
                }

              </SimpleGrid>


            </Container>
          </Box>

        </Styles>
      </Layout>
    )
  }
}

export const query = graphql`
  {
    shop: allContentfulStore {
      nodes {
        title
        slug
        id
        price

        body {
          body
        }
        
        resources {
          fluid {
            srcWebp
            srcSetWebp
            srcSet
            src
            aspectRatio
            base64
          }
        }
      }
    }
  }
`